import * as React from 'react'
import cx from 'classnames'
import anime from 'animejs'
import { PaginationButton } from '../button'
import { CaseStudyCard } from '.'
import styles from './continue-reading.module.scss'

const [SLIDE_WIDTH] = [498 + 14 * 2]

function useCarousel(count) {
  const [active, setActive] = React.useState(0)
  const onNext = () => setActive(active + 1 === count ? 0 : active + 1)
  const onPrevious = () => setActive(active - 1 < 0 ? count - 1 : active - 1)
  const parent = React.useRef()
  const slides = new Array(count).fill(true).map(() => React.useRef())
  const refs = { parent, slides }
  React.useEffect(() => animateSlideChange(refs, active), [active])
  return { refs, active, setActive, onNext, onPrevious }
}

export default function ContinueReading({ list }) {
  const { refs, onPrevious, onNext } = useCarousel(list.length)
  return (
    <footer className={styles.section}>
      <div className="container container--grid">
        <div className="container__row">
          <div className={styles.section__header}>
            <h2 className="type-label-lg">Continue Reading</h2>
            <div className={styles.section__pagination}>
              <PaginationButton
                onClick={onPrevious}
                direction="previous"
                aria-label="Previous"
              />
              <PaginationButton onClick={onNext} aria-label="Next" />
            </div>
          </div>
        </div>
      </div>

      {/* edge to edge native scroll snapping */}
      <ul className={cx(styles.mobile, 'list-reset')}>
        {list.map(c => (
          <li key={c.id} className={styles.mobile__item}>
            <CaseStudyCard
              appearance="compact"
              image={{
                fluid: c.listImage.fluid,
                alt: c.listImage.description,
                ratio: 2 / 3,
              }}
              title={c.title}
              company={c.companyName}
              description={c.listDescription.listDescription}
              tags={c.contentTags}
              url={`/business-impact/${c.slug}`}
            />
          </li>
        ))}
      </ul>

      {/* anime js animated buttons */}
      <div className="container container--grid">
        <div className="container__row">
          <ul ref={refs.parent} className={cx(styles.desktop, 'list-reset')}>
            {list.map((c, idx) => (
              <li
                key={c.id}
                ref={refs.slides[idx]}
                className={styles.desktop__item}
              >
                <CaseStudyCard
                  appearance="compact"
                  image={{
                    fluid: c.listImage.fluid,
                    alt: c.listImage.description,
                    ratio: 2 / 3,
                  }}
                  title={c.title}
                  company={c.companyName}
                  description={c.listDescription.listDescription}
                  tags={c.contentTags}
                  url={`/business-impact/${c.slug}`}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  )
}

const getTransformX = () => SLIDE_WIDTH
const getSlideX = n => n * getTransformX()

function animateSlideChange({ slides }, idx) {
  anime({
    duration: 500,
    easing: 'easeInOutSine',
    translateZ: 0,
    translateX: getSlideX(idx) * -1,
    targets: slides.map(({ current }) => current),
  })
}
